import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import usePriority from './usePriority.mjs'

export default function PropertiesControllerSelectPriority(props) {
    const {pairs} = usePriority()

    return (
        <Select
            mapOption={{label: e => e.nameCn}}
            options={pairs}
            prop="ucPriority"
            {...props}
        />
    )
}
